import { writable } from 'svelte/store'

function createFeatureFlagStore() {
  const { subscribe, set, update } = writable({
    enableAdminPanel: false,
  })

  return {
    subscribe,
    set,
    setFlag: (key, value) => update(flags => ({ ...flags, [key]: value })),
    getFlag: key => {
      let value
      subscribe(flags => {
        value = flags[key]
      })()
      return value
    },
  }
}

export const featureFlagStore = createFeatureFlagStore()
